import React, { useMemo } from 'react';
import { LayoutWithHeader } from '@components/layout/LayoutWithHeader';
import routes from '@config/routes';
import { CmsContentRenderer } from '@features/cms/components/cms-content-renderer';
import { ButtonLink, FlexView } from '@goodfynd/ui';

const AuthFallback = () => {
  const loginHref = useMemo(() => {
    const loginHref = routes.account.signIn;
    if (window.location.pathname === '/') {
      return loginHref;
    }

    return `${loginHref}?returnUrl=${window.location.href}`;
  }, []);

  return (
    <LayoutWithHeader>
      <FlexView align="center" direction="column" margin={40} size={1}>
        <CmsContentRenderer slug="vendor-dashboard-login" />
        <ButtonLink content="Log in here" href={loginHref} />
      </FlexView>
    </LayoutWithHeader>
  );
};

export default AuthFallback;
